import type { RouteRecordRaw } from 'vue-router';

export const cartRoutes: Array<RouteRecordRaw> = [
  {
    path: '/cart',
    name: 'cart',
    redirect: '/cart/list',
    component: () => import('pages/trade/admin/cart/TradeCart.vue'),
    meta: {
      title: 'Carts',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'cartList',
        component: () => import('pages/trade/admin/cart/CartList.vue'),
        meta: {
          title: 'Carts List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'cartDetail',
        component: () => import('pages/trade/admin/cart/CartDetail.vue'),
        meta: {
          title: 'Cart Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'cartNew',
        component: () => import('pages/trade/admin/cart/CartNew.vue'),
        meta: {
          title: 'New Cart',
          requiresAuth: true,
        },
      },
      {
        path: 'explorer/:folderId?',
        name: 'cartExplorer',
        component: () => import('pages/trade/admin/cart/CartExplorer.vue'),
        meta: {
          title: 'Carts Explorer',
          requiresAuth: true,
        },
      },
    ],
  },
];
